import {useData} from "vike-vue/useData";

export default (pageContext) => {
  const {category} = pageContext.data

  return `${category.name} posts on Seedr Pulse`
}
